module.exports = __webpack_public_path__ + "img/small_whale28.3e0ce9fc.jpg";